<!-- Wrapper principale per gestire il layout Flexbox -->
<div class="dialog-root-container">

  <!-- SEZIONE FISSA: Titolo -->
  <h1 mat-dialog-title class="no-margin">
    DETTAGLIO PROPOSTA COMPETENZA
    <mat-icon class="close-icon" (click)="onNoClick()">close</mat-icon>
  </h1>

  <!-- SEZIONE FISSA: Intestazione e Badge -->
  <div class="intestazione margin-bottom-10">
    <div class="competence-badges-inline">
      <strong>Nome competenza: </strong>
      <span>{{data.competenza.descrizione}}</span>
      <span *ngIf="data.competenza.green" class="competence-badge green-badge-custom">Green</span>
      <span *ngIf="data.competenza.digital" class="competence-badge green-badge-custom">Digitale</span>
    </div>
  </div>

  <!-- SEZIONE SCROLLABILE: Contenuto centrale -->
  <div class="dialog-scrollable-content">
    <div class="wrapper-content-box">
      <div class="content-box">
        <mat-list role="list">
          <mat-list-item role="listitem">
            <strong class="caption">Stato proposta:</strong>
            <span class="grey noFloat">{{data.competenza.stato.descrizione}}</span>
          </mat-list-item>
          <mat-list-item role="listitem">
            <strong class="caption">Tipologia:</strong>
            <span class="grey noFloat">{{data.competenza.tipologia.descrizione}}</span>
          </mat-list-item>
          <mat-list-item *ngIf="data.competenza.tipologia.id === 6" role="listitem">
            <strong class="caption">Sottocategoria:</strong>
            <span class="grey noFloat">{{data.competenza.descrizioneTCategoriaDigitale}}</span>
          </mat-list-item>
          <mat-list-item *ngIf="data.competenza.tipologia.id === 3" role="listitem">
            <strong class="caption">Sottocategoria:</strong>
            <span class="grey noFloat">{{data.competenza.descrizioneTCategoriaBase}}</span>
          </mat-list-item>
          <mat-list-item role="listitem">
            <strong class="caption">Livello EQF:</strong>
            <span class="grey noFloat">{{data.competenza.eqfCompetenza}}</span>
          </mat-list-item>
        </mat-list>
      </div>
      <div class="content-box">
        <mat-list role="list">
          <mat-list-item role="listitem" *ngIf="data.competenza.tipologia.id === 1 && data.competenza.tipoArea">
            <strong class="caption">AREA:</strong>
            <span class="grey noFloat">{{data.competenza.tipoArea.descrizione}}</span>
          </mat-list-item>
          <mat-list-item role="listitem">
            <strong class="caption">Invio proposta:</strong>
            <span class="grey noFloat">{{data.competenza.dataInvio | date:'dd/MM/yyyy'}}</span>
          </mat-list-item>
          <mat-list-item role="listitem">
            <strong class="caption">Validazione/rifiuto:</strong>
            <span class="grey noFloat">{{data.competenza.dataValidazioneRifiuto | date:'dd/MM/yyyy'}}</span>
          </mat-list-item>
          <mat-list-item role="listitem">
            <strong class="caption">Approvazione:</strong>
            <span class="grey noFloat">{{data.competenza.dataApprovazione | date:'dd/MM/yyyy'}}</span>
          </mat-list-item>
        </mat-list>
      </div>
    </div>

    <div class="d-flex width-full">
      <!-- Colonna Referenziazioni -->
      <div style="width: 50%">
        <div *ngIf="data.competenza.visualizzaReferenziazioni.booleano && ((listaAda?.length > 0) || (listaIstat?.length > 0) || (listaAteco?.length > 0) || (listaIsco?.length > 0))">
          <h4 class="sectionTitle">REFERENZIAZIONI</h4>

          <mat-list role="list" *ngIf="listaAda?.length > 0">
            <mat-list-item role="listitem">
              <strong class="caption">ADA:</strong>
              <span class="grey noFloat" *ngFor="let codice of listaAda" matTooltip={{codice.descrizione}}>
                <svg height="12" width="12"><circle cx="6" cy="7" r="4" stroke="black" stroke-width="1" fill="#008047" /></svg>
                <p class="mat-mdc-text-field-wrapper">{{codice.codiceAda}} - {{codice.descrizione}}</p>
              </span>
            </mat-list-item>
          </mat-list>

          <mat-list role="list" *ngIf="listaIstat?.length > 0">
            <mat-list-item role="listitem">
              <strong class="caption">Classificazione Nazionale delle Professioni ISTAT:</strong>
              <span class="grey noFloat" *ngFor="let codice of listaIstat" matTooltip={{codice.descrizione}}>
                <svg height="12" width="12"><circle cx="6" cy="7" r="4" stroke="black" stroke-width="1" fill="#008047" /></svg>
                {{codice.codiceIstat}} - {{codice.nome}}
              </span>
            </mat-list-item>
          </mat-list>

          <mat-list role="list" *ngIf="listaAteco?.length > 0">
            <mat-list-item role="listitem">
              <strong class="caption">Classificazione Nazionale delle Attività economiche ATECO:</strong>
              <span class="grey noFloat" *ngFor="let codice of listaAteco" matTooltip={{codice.descrizione}}>
                <svg height="12" width="12"><circle cx="6" cy="7" r="4" stroke="black" stroke-width="1" fill="#008047" /></svg>
                {{codice.codiceAteco}} - {{codice.descrizione}}
              </span>
            </mat-list-item>
          </mat-list>

          <mat-list role="list" *ngIf="listaIsco?.length > 0">
            <mat-list-item role="listitem">
              <strong class="caption">Classificazione Internazionale delle Professioni ISCO:</strong>
              <span class="grey noFloat" *ngFor="let codice of listaIsco" matTooltip={{codice.descrizione}}>
                <svg height="12" width="12"><circle cx="6" cy="7" r="4" stroke="black" stroke-width="1" fill="#008047" /></svg>
                {{codice.codiceIsco}} - {{codice.descrizione}}
              </span>
            </mat-list-item>
          </mat-list>
        </div>
      </div>

      <!-- Colonna Abilità e Conoscenze -->
      <div style="width: 50%;">
        <h4 class="sectionTitle">ELENCO ABILITA' E CONOSCENZE</h4>
        <mat-list role="list" *ngIf="data.competenza.listaConoscenze && data.competenza.listaConoscenze.length>0">
          <mat-list-item role="listitem">
            <strong class="caption">Elenco delle Conoscenze</strong>
            <span class="grey noFloat" *ngFor="let item of data.competenza.listaConoscenze" matTooltip={{item.descrizione}}>
              <svg height="12" width="12"><circle cx="6" cy="7" r="4" stroke="black" stroke-width="1" fill="#008047" /></svg>
              {{item.descrizione}}
            </span>
          </mat-list-item>
        </mat-list>
        <mat-list role="list" *ngIf="data.competenza.listaAbilita && data.competenza.listaAbilita.length>0">
          <mat-list-item role="listitem">
            <strong class="caption">Elenco delle Abilità</strong>
            <span class="grey noFloat" *ngFor="let item of data.competenza.listaAbilita" matTooltip={{item.descrizione}}>
              <svg height="12" width="12"><circle cx="6" cy="7" r="4" stroke="black" stroke-width="1" fill="#008047" /></svg>
              {{item.descrizione}}
            </span>
          </mat-list-item>
        </mat-list>
      </div>
    </div>
  </div>

  <!-- SEZIONE FISSA: Footer Azioni -->
  <div mat-dialog-actions class="dialog-footer">
    <button mat-fab extended class="searchbox-buttons save-button" (click)="onNoClick()">
      <mat-icon>close</mat-icon>Chiudi
    </button>
    <button mat-fab extended class="searchbox-buttons save-button" (click)="reportPropostaCompetenzaPdf()" *ngIf="this.pdfVisible">
      <mat-icon>picture_as_pdf</mat-icon>{{data.competenza.testoPulsanteStampaPdf}}
    </button>
    <button mat-fab extended class="searchbox-buttons save-button" (click)="reportPropostaCompetenzaXls()" *ngIf="this.xlsVisible">
      <mat-icon>download</mat-icon>{{data.competenza.testoPulsanteStampaXls}}
    </button>
  </div>

</div>
